import { Customer } from "../../../customer/shared/customer.model";
import { Loan } from "../../../loan/shared/loan";
import { Loantransaction } from "../../../loan/shared/loantransaction.model";
import { Savings } from "../../../savings/shared/savings.model";
import { Savingstransaction } from "../../../savings/shared/savingstransaction.model";
import { Centerlink } from "../../../customer/shared/centerlink.model";

export class Datamanagement {
    
    public customer = new Customer();
    public loan = new Loan();
    public loantransaction = new Loantransaction();
    public savings = new Savings();
    public savingstransaction = new Savingstransaction();
    public centerlink = new Centerlink();

}
